import i18next from "i18next";
import { initReactI18next } from "react-i18next";

//Import all translation files
import translationEnglish from "./locales/en.json";
import translationSpanish from "./locales/es.json";
import translationCatalan from "./locales/cat.json";
import translationEuskera from "./locales/eus.json";
import translationGalego from "./locales/gal.json";

const resources = {
  en: {
    translation: translationEnglish,
  },
  es: {
    translation: translationSpanish,
  },
  cat: {
    translation: translationCatalan,
  },
  eus: {
    translation: translationEuskera,
  },
  gal: {
    translation: translationGalego,
  },
};

i18next.use(initReactI18next).init({
  resources,
  supportedLngs: ["en", "es", "cat", "eus", "gal"],
  lng:
    sessionStorage.getItem(process.env.REACT_APP_SESSIONSTORAGE_LANG!) || "es", // default language
});

export default i18next;
